module.exports = {"513426001":"鱼城街道","513426002":"金江街道","513426100":"鲹鱼河镇","513426101":"铅锌镇","513426102":"堵格镇","513426103":"姜州镇","513426104":"乌东德镇","513426105":"淌塘镇","513426106":"铁柳镇","513426107":"嘎吉镇","513426108":"满银沟镇","513426109":"新街镇","513426110":"鲁吉镇","513426111":"大崇镇","513426112":"松坪镇","513426202":"老君滩乡","513426203":"江西街乡","513426235":"溜姑乡","513426251":"野租乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513426.json
// module id = 2567
// module chunks = 0